import { motion } from "framer-motion";
import logo from "@/assets/logo.svg";
import background from "@/assets/menu/especialidades/RONDA MARINERA.webp";
import CardsHolder from "../CardsHolder";
import { Link } from "react-router";

const companyName = "El Verde";
const description =
  "Restaurante de Comida Costeña: Caldo de Bolas, Cazuelas, Banderas, Encebollados, Guatita, Camarones, Majariscos, Ceviches, Tigrillos, Bolones y Más...";

export default function LinkPresentation() {
  return (
    <div
      className="fixed inset-0 w-screen h-screen overflow-y-auto flex flex-col bg-cover bg-center"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="fixed bg-cover bg-center w-screen h-screen inset-0 bg-black/40 z-0" />
      <div className="relative z-10 flex flex-col items-center min-h-full w-full py-6">
        <motion.header
          className="shrink-0 w-full flex flex-col items-center"
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex flex-row items-center justify-center mb-4 px-4 py-2 w-full gap-6">
            <Link to="/.">
              <div className="flex items-center justify-center rounded-full aspect-square w-24 h-24 sm:w-32 sm:h-32 drop-shadow-lg bg-accent p-3 sm:p-5">
                <img src={logo} alt="Logo" className="h-14 w-auto sm:h-20" />
              </div>
            </Link>
            <div className="flex flex-col items-start justify-center">
              <h1 className="text-5xl font-bold text-white text-left mb-2">
                {companyName}
              </h1>
              <p className="text-xl text-gray-200 max-w-xl text-left">
                {description}
              </p>
            </div>
          </div>
        </motion.header>
        <motion.header
          className="flex justify-center w-full shrink-0"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <CardsHolder />
        </motion.header>
      </div>
    </div>
  );
}
